import { UiOption } from '@/lib/helpers';
import { PropModel } from '../prop.model';

export type PsSupportLevel = 'access' | 'request-intercept' | 'intercept';

export type PsServiceState =
  | 'enabled'
  | 'disabled'
  | 'passthrough-before-auth'
  | 'passthrough-before-access-control'
  | 'passthrough-before-data-handling';

type PsSupportDeprecated = {
  value: boolean;
  eolTimestamp?: number;
  description?: string;
};

export type PsFeatureMatrix = {
  request: { enabled: boolean };
  response: { enabled: boolean };
  license: { enabled: boolean };
  fileUpload: { enabled: boolean };
  mcp: { enabled: boolean };
};

export const PsFeatureOpts: UiOption[] = [
  { value: 'request', label: 'Request' },
  { value: 'response', label: 'Response' },
  { value: 'license', label: 'License' },
  { value: 'fileUpload', label: 'File Upload' },
  { value: 'mcp', label: 'MCP' },
];

export class PsSupportConfig extends PropModel {
  level: PsSupportLevel;
  serviceState: PsServiceState;
  stateCode: number;
  deprecated?: PsSupportDeprecated;
  featureMatrix: PsFeatureMatrix;

  constructor(props: Record<string, unknown>) {
    super();
    const data = (props || {}) as Record<keyof PsSupportConfig, unknown>;
    this.level = (data.level as PsSupportLevel) || 'access';
    this.serviceState = (data.serviceState as PsServiceState) || { disabled: false, code: 0 };
    this.stateCode = (data.stateCode as number) || 0;
    if (data.deprecated) {
      this.deprecated = data.deprecated as PsSupportDeprecated;
    }

    this.featureMatrix = {
      request: { enabled: false },
      response: { enabled: false },
      license: { enabled: false },
      fileUpload: { enabled: false },
      mcp: { enabled: false },
    };

    if (data.featureMatrix) {
      this.featureMatrix = { ...this.featureMatrix, ...(data.featureMatrix as PsFeatureMatrix) };
    }
  }
}
